/**
 * HACK is this a CDP question?
 * @param {*} questionData
 * @returns {boolean}
 */
export function isCDPQuestion(questionData) {
  return questionData?.regulation === "CDP";
}
